import React from "react";
import { motion } from "framer-motion";
import "./InteractiveHoverButton.css";

export const InteractiveHoverButton = ({ children, className = "", ...props }) => {
  return (
    <motion.div
      whileHover="hover"
      initial="initial"
      className={`interactive-hover-button ${className}`}
      data-cursor="pointer"
      {...props}
    >
      <div className="button-content-inner">
        {/* The dot that expands on hover */}
        <motion.div
          className="dot-bg"
          variants={{
            hover: { scale: 65 },
            initial: { scale: 1 }
          }}
          transition={{ duration: 0.5, ease: [0.4, 0, 0.2, 1] }}
        />
        
        {/* Initial text and dot */}
        <motion.div
          className="content-initial"
          variants={{
            hover: { x: 20, opacity: 0 },
            initial: { x: 0, opacity: 1 }
          }}
        >
          <div className="small-dot" />
          <span className="button-text">{children}</span>
        </motion.div>

        {/* Hover state text and arrow */}
        <motion.div
          className="content-hover"
          variants={{
            hover: { x: 0, opacity: 1 },
            initial: { x: -20, opacity: 0 }
          }}
        >
          <span className="button-text">{children}</span>
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" className="arrow-icon">
            <path d="M8.14645 3.14645C8.34171 2.95118 8.65829 2.95118 8.85355 3.14645L12.8536 7.14645C13.0488 7.34171 13.0488 7.65829 12.8536 7.85355L8.85355 11.8536C8.65829 12.0488 8.34171 12.0488 8.14645 11.8536C7.95118 11.6583 7.95118 11.3417 8.14645 11.1464L11.2929 8H2.5C2.22386 8 2 7.77614 2 7.5C2 7.22386 2.22386 7 2.5 7H11.2929L8.14645 3.85355C7.95118 3.65829 7.95118 3.34171 8.14645 3.14645Z" fill="currentColor" fillRule="evenodd" clipRule="evenodd"></path>
          </svg>
        </motion.div>
      </div>
    </motion.div>
  );
};